import { message } from "antd";
import { putVoiceSettings } from "../service";

function useVoiceSettings({ syncAssistant, workspaceId, assistantId }) {
  const updateVoiceSettings = async (payload) => {
    message.loading("Updating settings");
    try {
      const response = await putVoiceSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Settings updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            voiceSettings: response.data,
          };
        });
      }
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update settings");
      console.error("Error updating voice settings");
    }
  };
  return { updateVoiceSettings };
}

export { useVoiceSettings };
